export default __webpack_public_path__ + "static/media/ElissaLovelace.be610c6b.png";